import { ToursListing } from "../components/ToursListing";
import { IMAGES } from "../data/site";

export default function InternationalTours() {
  return (
    <ToursListing
      type="international"
      eyebrow="Around the World"
      title="International Tours"
      subtitle="Halong Bay to the Himalayas of Bhutan, the temples of Nepal to sacred Kailash — the world, expertly curated."
      image={IMAGES.tropical}
    />
  );
}
